import { Box, Chip, Typography } from '@mui/material';
import { ServiceMetricsDataCellProps } from '../types';
import { DATA_TYPES, dataTypes } from '@constants';
import * as IntegrationTypes from 'IntegrationModule/types';

const ServiceMetricsSummaryCell = ({ dataTypeMetrics }: ServiceMetricsDataCellProps) => {
  // Calculate summary stats
  let totalIssues = 0;
  let totalSynced = 0;
  const dataTypesWithData: string[] = [];

  DATA_TYPES.forEach((dataType) => {
    const countsByDataType: IntegrationTypes.CountPerDataTypeValues =
      dataTypeMetrics[dataType] || {};

    const totalCreate = countsByDataType.totalCreate ?? 0;
    const totalUpdate = countsByDataType.totalUpdate ?? 0;
    const totalCreateAndUpdate = totalCreate + totalUpdate;

    if (totalCreateAndUpdate > 0) {
      const dataTypeConfig = dataTypes.find((dt) => dt.value === dataType);
      if (dataTypeConfig) {
        dataTypesWithData.push(dataTypeConfig.label);
      }
      totalIssues += totalCreate;
      totalSynced += totalCreateAndUpdate;
    }
  });

  if (totalSynced === 0) {
    return (
      <Typography variant="caption" color="textSecondary">
        No data
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
      }}
    >
      <Chip
        label={`${totalIssues} / ${totalSynced}`}
        size="small"
        color={totalIssues > 0 ? 'warning' : 'success'}
      />
      <Typography variant="caption" color="textSecondary">
        ({dataTypesWithData.length} types)
      </Typography>
    </Box>
  );
};

export default ServiceMetricsSummaryCell;
